import React from 'react';
import { inject, observer } from 'mobx-react';
import Preloader from '@components/Preloader';
import { Labels, Label, LabelLink } from '@components/Sidebar/style';
import routes from '@routes';

const LabelsList = ({ musicStore: { labels, labelsLoading }, ofStems }) => {
  if (labelsLoading || !labels.length) {
    return <Preloader />;
  }

  return (
    <Labels>
      {labels.map(label => (
        <Label key={`label-list-item_${label.id}`}>
          <LabelLink
            to={routes.label(label.uuid, ofStems ? 'stems' : 'albums')}
          >
            <img src="/images/icons/vinyl.svg" alt="" />
            {label.name}
          </LabelLink>
        </Label>
      ))}
    </Labels>
  );
};

export default inject('musicStore')(observer(LabelsList));
